import miniFeatures from './miniFeatures';
import { FeatureName, isFeatureEnabled } from 'owa-feature-flags';

export type MiniFeatures = keyof typeof miniFeatures;

export default function isMiniFeatureEnabled(feature: MiniFeatures) {
    return isFeatureEnabled(feature as FeatureName);
}
